module.exports = __webpack_public_path__ + "img/thumb_31.d26548cc.jpg";